import React, { Component } from 'react';
import { Tabs, TabList, Tab, DragTab, PanelList, Panel, ExtraButton } from 'react-tabtab';
import * as customStyle from 'react-tabtab/lib/themes/material-design';
import BasicSettings from './BasicSettings';
import GenerateCert from './GenerateCert';
import BackGroundBorder from './BackGroundBorder';
import PreviewImage from './PreviewImage';
import { data } from '../../../images/data';
import Constant from '../../../Constant.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class CertificateSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modelOpen: false,
      urlImage: "",
      allBackgroundImages: [],
      allImages: data,
      isPreviewEnabled: false,
      previewText: '',
      validity: new Date()
    };
    this.text = "";
  }
  getCertificateData = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/certificate_image/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          this.setState({
            certificateData: result.data[0],
            certificateImgId: result.data[0].id,
            previewText: result.data[0].template,
            selectedImg: result.data[0].media_id,
            urlImage: result.data[0].certificate_image_media.url,
            validity: new Date(result.data[0].validity),
          });
        }
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  }
  getCertificateImages = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/getCertificates", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          this.setState({ allBackgroundImages: result.data });
        }
      })
      .catch((error) => console.log("error", error));
  };
  handleOpenModel = () => {
    const { modelOpen } = this.state;
    this.setState({
      modelOpen: !modelOpen,
    });
  };

  handleToggle = () => {
    const { isPreviewEnabled } = this.state;
    this.setState({
      isPreviewEnabled: !isPreviewEnabled,
    });
  };

  handleImages = (event) => {
    console.log("imageURL", event.target.name);
    this.setState({
      urlImage: event.target.name,
      selectedImg: event.target.id,
    });
  };

  handleUpdate = (text) => {
    this.text = text;
  };

  updatePreview = (event) => {
    event.preventDefault();
    this.setState({
      previewText: this.text,
    });
  };

  removeAll = () => {
    this.setState = {
      urlImage: "",
    };
  };

  onSaveCertificate = () => {
    var that = this;
    if (that.state.certificateData === undefined) {
      that.addCertificateData();
    } else {
      that.updateCertificateData();
    }
  }
  updateCertificateData = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));
    urlencoded.append("certificateImgId", this.state.certificateImgId);
    urlencoded.append("mediaId", this.state.selectedImg);
    urlencoded.append("validity", new Date(this.state.validity).toISOString());
    urlencoded.append("template", this.state.previewText);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/certificate_image/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          alert('certificate Updated');
          window.location.reload();
        }
      })
      .catch((error) => console.log("error", error));

  }
  addCertificateData = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));
    urlencoded.append("mediaId", this.state.selectedImg);
    urlencoded.append("validity", new Date(this.state.validity).toISOString());
    urlencoded.append("template", this.state.previewText);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/certificate_image/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          alert('certificate added');
          window.location.reload();
        }
      })
      .catch((error) => console.log("error", error));

  }
  componentWillMount() {
    const previewText = `<p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><h4 class="ql-align-center"><strong class="ql-font-serif">{{organization}}</strong></h4><p class="ql-align-center"><br></p><h1 class="ql-align-center"><strong class="ql-font-serif">Certification</strong></h1><p class="ql-align-center"><br></p><p class="ql-align-center"><strong class="ql-font-serif">This&nbsp;certification&nbsp;is&nbsp;awarded&nbsp;to</strong></p><p class="ql-align-center"><br></p><p class="ql-align-center"><strong class="ql-font-serif"><em><u>{{first_name}}&nbsp;{{last_name}}</u></em></strong></p><p class="ql-align-center"><br></p><p class="ql-align-center"><strong class="ql-font-serif">For&nbsp;successfully&nbsp;completing&nbsp;the&nbsp;course</strong></p><p class="ql-align-center"><br></p><p class="ql-align-center"><strong class="ql-font-serif"><u>{{course_name}}</u></strong></p><p class="ql-align-center"><strong class="ql-font-serif">${new Date().getDay()}-${new Date().getMonth()}-${new Date().getFullYear()}&nbsp;</strong></p><p class="ql-align-center"><strong class="ql-font-serif">---------------------------</strong></p><p class="ql-align-center"><strong class="ql-font-serif">Issue&nbsp;Date</strong></p>    `;
    this.setState({
      previewText: "",
    });
    this.getCertificateImages();
    this.getCertificateData();
  }
  handleDay = (date) => {
    this.setState({
      validity: date
    });
  };
  render() {
    const OPTIONS = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
    ].map((data) => {
      return <option value={`"${data}`}>{data} month</option>;
    });
    return (
      <div>
        <div className="row m-0 mt-3">
          <div className="col-md-12">
            <div class="form-group row">
              <label class="col-form-label col-2 text-right" for="inputDefault">
                Certification Duration
              </label>
              <DatePicker
                selected={this.state.validity}
                onChange={this.handleDay}
                dateFormat="MMMM d, yyyy"
              />
              {/* <select class="custom-select col-9">{OPTIONS}</select> */}
            </div>
            <div class="form-group row">
              <div class="col-1" />
              <div class="col-10">
                <Tabs customStyle={customStyle}>
                  <TabList>
                    <Tab>
                      <i class="fas fa-sliders-h"></i> Back Ground
                    </Tab>
                    <Tab>
                      <i class="fas fa-users"></i> Template
                    </Tab>
                    {/* <Tab>
                    <i class="fas fa-palette"></i> Themes
                  </Tab>
                  <Tab>
                    <i class="fas fa-certificate"></i> Certifications
                  </Tab>
                  <Tab>
                    <i class="fas fa-gamepad"></i> Gamification
                  </Tab>
                  <Tab>
                    <i class="fas fa-shopping-cart"></i> E-commerce
                  </Tab>
                  <Tab>
                    <i class="fas fa-globe"></i> Domain
                  </Tab>
                  <Tab>
                    <i class="fas fa-hand-point-up"></i> Subscription
                  </Tab> */}
                  </TabList>
                  <PanelList>
                    <Panel>
                      <BackGroundBorder
                        handleImage={this.handleImages}
                        selectedImg={this.state.selectedImg}
                        allImages={this.state.allBackgroundImages}
                      />
                    </Panel>
                    {/* <Panel>
                  <UsersSettings />
                </Panel>
                <Panel>
                  <ThemeSettings />
                </Panel> */}
                    <Panel>
                      <GenerateCert
                        previewText={this.state.previewText}
                        handleUpdate={this.handleUpdate}
                      />
                    </Panel>
                    {/* <Panel>Gamification</Panel>
                  <Panel>E-commerce</Panel> */}
                    {/* <Panel>
                  <DomainSettings />
                </Panel>
                <Panel>
                  <SubscriptionSettings />
                </Panel> */}
                  </PanelList>
                </Tabs>
              </div>
              <div class="col-1" />
            </div>
          </div>
        </div>
        <hr />
        <div class="row text-center">
          <button
            onClick={this.handleToggle}
            class="btn btn-primary ml-3 mb-3 mr-3"
          >
            Toggle Certificate
          </button>
          <button
            class="btn btn-warning ml-3 mb-3 mr-3"
            onClick={this.updatePreview}
          >
            Update Changes
          </button>
        </div>
        {this.state.isPreviewEnabled ? (
          <PreviewImage
            css={this.state.urlImage}
            certificateText={this.state.previewText}
            isOpen={this.state.isPreviewEnabled}
            handleToggle={this.handleToggle}
          />
        ) : (
            ""
          )}
        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary" onClick={this.onSaveCertificate}> Save</div> or{" "}
          <a href="#/admin/dashboard" className="btn-link">
            Cancel
          </a>
        </div>
      </div>
    );
  }
}
